export const GLOBAL_STATS_RECEIVED = "GLOBAL_STATS_RECEIVED";
export const MONTHLY_STATS_RECEIVED = "MONTHLY_STATS_RECEIVED";
